








































































































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import splitContent from '@/shared/directive/split-content';
import formatCompetence from '@/shared/directive/format-competence';
import Contract from '@/domain/contract/entity/contract.entity';
import ContractItem from '@/domain/contract/entity/contract-item.entity';
import ExecutionSuccessModal from '@/shared/modal/modal-success.component.vue';
import BillingModalError from '@/shared/billing-error/billing-modal-error.component.vue';
import Datasource from '@/domain/business-unit/entity/datasource.entity';
import ContractInstance from '@/domain/contract/entity/contract-instance.entity';
import UserBusinessUnitService from '@/domain/business-unit/service/business-unit.store';
import UserProfile from '@/domain/access/domain/profile.enum';
import TaskService from '@/domain/task/task.service';
import Header from './header.json';
import ManageCalculationButton from './manage-calculation/manage-calculation-button.vue';
import EditObservationButton from './observation/edit-observation-button.vue';
import EditObservationModal from './observation/edit-observation-modal.component.vue';
import ContractService from '../../../../domain/contract/service/contract.service';
import SelectInstanceButton from './instance/select-instance-button.vue';
import SelectInstanceModal from './instance/select-instance-modal.component.vue';
import PerformBillingButton from './perform-billing/perform-billing-button.vue';
import PerformBillingModal from './perform-billing/perform-billing-modal.component.vue';
import PerformBillingAllItemsModal from './perform-billing/perform-billing-all-items-modal.component.vue';
import ExchangeConfigurationButton from './exchange-configuration/exchange-configuration-button.vue';
import ExchangeConfigurationModal from './exchange-configuration/exchange-configuration-modal.component.vue';
import SelectDatasourceButton from './datasource/select-datasource-button.vue';
import SelectDatasourceModal from './datasource/select-datasource-modal.component.vue';
import ContractItemAutomationButton from './contract-item-automation/contract-item-automation-button.component.vue';
import ContractItemAutomationModal from './contract-item-automation/contract-item-automation-modal.component.vue';
import ContractBillingDailyModal from '../../contract-modal/contract-billing-daily-modal.component.vue';
import BillingItensModalExecute from '../../contract-modal/billing-itens-modal-execute.component.vue';

@Component({
  filters: { splitContent, formatCompetence },
  components: {
    VbTooltipSlot,
    ManageCalculationButton,
    EditObservationButton,
    EditObservationModal,
    SelectInstanceButton,
    SelectInstanceModal,
    PerformBillingButton,
    PerformBillingModal,
    PerformBillingAllItemsModal,
    ExecutionSuccessModal,
    BillingModalError,
    ExchangeConfigurationButton,
    ExchangeConfigurationModal,
    SelectDatasourceButton,
    SelectDatasourceModal,
    ContractItemAutomationButton,
    ContractItemAutomationModal,
    ContractBillingDailyModal,
    BillingItensModalExecute,
  },
})

export default class Items extends Vue {
  @Prop({ default: () => [] }) items!: Array<ContractItem>;

  @Prop({ default: () => [] }) instances!: ContractInstance[];

  @Prop({ default: () => [] }) datasources!: Datasource[];

  @Prop({ required: true }) businessUnitId!: string;

  @Prop({ required: false, default: '' }) billingEmails!: string;

  @Prop({ required: true }) isEditable!: boolean;

  @Prop({ required: false }) customHeader?: any;

  @Prop({ required: true }) isAdministrator!: boolean;

  @Prop({ required: true }) profile!: string;

  @Prop({ required: true }) contract!: Contract;

  @Prop({ type: Boolean, default: false })
  billingDaily!: boolean;

  @Prop({ type: Boolean, default: false })
  enableRevisionFlow = UserBusinessUnitService.currentBusinessUnit.enableRevisionFlow;

  @Prop({ type: Boolean, default: false })
  autoPurchase!: boolean;

  showEditObservationModal = false;

  showPerformBillingModal = false;

  showPerformBillingAllModal = false;

  showSelectDatasourceModal = false;

  showContractItemAutomationModal: boolean = false;

  itemToEditAutomations: string = '';

  editObservationModalKey = 0;

  instanceSelectionKey = 0;

  datasourceSelectionKey = 0;

  contractItemIdToBill: string = '';

  contractItemToConfigExchange: ContractItem = ContractItem.of({});

  performBillingAllItemsModalKey = 1;

  itemToEditObservation = ContractItem.of({});

  instanceSelectionShow: boolean = false;

  itemToSelectInstances = ContractItem.of({});

  itemToSelectDatasource = ContractItem.of({});

  showExecutionSuccessModal = false;

  successExecutionMessage = 'Execução realizada com sucesso!'

  showBillingModalError = false;

  executionError = false;

  showExchangeConfigModal = false;

  header = Header;

  search = '';

  showContractBillingDailyModal = false;

  showBillingItensModal = false;

  loadingBillingDaily: boolean = false;

  loadingBillingItens: boolean = false;

  get disabledBillingLabel(): string {
    if (this.contract.isPushOrderOutdated) return 'Ordem de Compra (PO) inválida';
    return 'Itens com inconsistências';
  }

  get inconsistentItems(): boolean {
    return this.items.some((item) => !item.hasCalculationRules);
  }

  get disabledBillingButton(): boolean {
    if (this.contract.isPushOrderOutdated) return true;
    return this.inconsistentItems || this.contract.startedAt === '' || this.contract.instances?.length === 0;
  }

  created() {
    if (this.customHeader) {
      this.header = this.customHeader;
    }
    this.editObservationModalKey += 1
  }

  hasInstances(): boolean {
    return this.instances && this.instances.filter((it) => it.active === true).length > 0;
  }

  successBindInstances() {
    this.$emit('successBindInstance');
    this.closeInstanceSelectionModal();
  }

  successBindDatasource() {
    this.$emit('successBindDatasource');
    this.closeDatasourceSelectionModal();
  }

  updateConfigSuccess() {
    this.$emit('updateConfigSuccess');
  }

  closeSuccessModal() {
    this.showExecutionSuccessModal = false;
  }

  handleExecutionSuccess() {
    this.showExecutionSuccessModal = true;
  }

  handleExecutionError() {
    this.showBillingModalError = true;
    this.executionError = true;
  }

  tooltipDisable(value: string) {
    return value.length < 50 ? 'disable' : '';
  }

  openPerformBillingModal(item: ContractItem) {
    if (this.contract.isBillingDaily) {
      this.showContractBillingDailyModal = true;
      this.contractItemIdToBill = item.id;
      return;
    }
    this.showPerformBillingModal = true;
    this.contractItemIdToBill = item.id;
  }

  openPerformBillingAllModal() {
    this.performBillingAllItemsModalKey += 1;
    this.showPerformBillingAllModal = true;
  }

  openExchangeConfigurationModal(item: ContractItem) {
    this.showExchangeConfigModal = true;
    this.contractItemToConfigExchange = item;
  }

  openEditObservationModal(item: ContractItem) {
    this.itemToEditObservation = item;
    this.showEditObservationModal = true;
  }

  openSelectDatasourceModal(item: ContractItem) {
    this.itemToSelectDatasource = item;
    this.showSelectDatasourceModal = true;
  }

  openInstanceSelectionModal(item: ContractItem) {
    this.itemToSelectInstances = item;
    this.instanceSelectionShow = true;
  }

  openContractItemAutomationModal(item: ContractItem): void {
    this.showContractItemAutomationModal = true;
    this.itemToEditAutomations = item.id;
    this.$nextTick(() => {
      const { automationsModal }: any = this.$refs;
      automationsModal.searchAutomations();
    });
  }

  closeEditObservationModal() {
    this.showEditObservationModal = false;
    this.editObservationModalKey += 1;
  }

  closeInstanceSelectionModal() {
    this.instanceSelectionShow = false;
    this.instanceSelectionKey += 1;
  }

  closeDatasourceSelectionModal() {
    this.showSelectDatasourceModal = false;
    this.datasourceSelectionKey += 1;
  }

  saveNewObservation(item: { id: string, observation: string }) {
    ContractService.updateObservation(this.businessUnitId, item.id, item.observation)
      .then(() => {
        this.itemToEditObservation.observation = item.observation;
        this.itemToEditObservation.hasCustomMacros = true;
        this.closeEditObservationModal();
        VbSnackbarService.showSuccess('Observação atualizada com sucesso');
      })
      .catch((error) => {
        VbSnackbarService.handleHttpError(error);
      })
  }

  closeContractItemAutomationModal(): void {
    this.showContractItemAutomationModal = false;
  }

  checkPermissionDisabled(): boolean {
    return !this.isAdministrator && this.profile !== UserProfile.SUPERVISOR;
  }

  checkPushOrderDisabled(): boolean {
    return this.contract.isPushOrderOutdated;
  }

  executeBillingDaily(competence: string): void {
    this.loadingBillingDaily = true;
    ContractService
      .performSingleBilling({
        businessUnitId: this.businessUnitId,
        contractItemId: this.contractItemIdToBill,
        invoiceCompetence: competence,
      })
      .then((taskId: string) => {
        this.handleExecuteBilling(taskId);
      })
      .catch((error) => {
        VbSnackbarService.handleHttpError(error);
        this.loadingBillingDaily = false;
      });
  }

  executeBillingItens(payload: any): void {
    this.loadingBillingItens = true;
    ContractService
      .performItemsBilling(
        this.businessUnitId,
        payload.items,
        payload.competence,
      )
      .then((taskIds: string[]) => {
        this.handleExecuteBillingItens(taskIds);
      })
      .catch((error) => {
        VbSnackbarService.handleHttpError(error);
        this.loadingBillingItens = false;
      });
  }

  private handleExecuteBilling(taskId: string) {
    TaskService.getTask(taskId, 10000)
      .then(() => {
        this.handleExecutionSuccess();
        this.showContractBillingDailyModal = false;
      })
      .catch(VbSnackbarService.handleHttpError)
      .finally(() => this.loadingBillingDaily = false);
  }

  async processTasksSequentially(taskIds: string[]) {
    await taskIds.reduce<Promise<void>>(
      (promise, taskId) => promise.then(() => TaskService.getTask(taskId, 10000).then(() => {})),
      Promise.resolve(),
    );
  }

  private handleExecuteBillingItens(taskIds: string[]) {
    this.processTasksSequentially(taskIds)
      .then(() => {
        this.handleExecutionSuccess();
        this.showBillingItensModal = false;
      })
      .catch(VbSnackbarService.handleHttpError)
      .finally(() => this.loadingBillingItens = false);
  }
}
